import React from 'react';

import { useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';

import { Text } from '@atlaskit/primitives/compiled/text';

import { asFormLocalTimeField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { formatLocalTimeValueForView } from '../../../../../../../../common/utils';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';

export const ViewLocalTimeInput = ({
	fieldId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);
	const formField = useFormField({ fieldId });
	const formLocalTimeField = asFormLocalTimeField(formField);
	const intl = useIntl();

	if (formLocalTimeField === undefined) {
		return <></>;
	}

	return (
		<Text testId="field-input-local-time-view">
			{formatLocalTimeValueForView(formLocalTimeField.value?.localTime, intl.locale)}
		</Text>
	);
};
